import React, { useState } from "react";

import HazardCard from "./HazardCard";
import HazardEditableCard from "./HazardEditableCard";

const HazardsList = React.memo(({ project, hazards }) => {
  const [editingHazards, setEditingHazards] = useState([]);

  const startHazardEditing = (hazard) => {
    setEditingHazards([...editingHazards, hazard.id]);
  };

  const stopHazardEditing = (hazard) => {
    setEditingHazards((prev) =>
      prev.filter((hazardId) => hazardId !== hazard.id)
    );
  };

  return (
    <div className="space-y-2 bg-grey-50">
      {hazards.map((hazard) => (
        <React.Fragment key={hazard.id || `new-hazard-${hazard.tempId || Date.now()}`}>
          {hazard.id && !editingHazards.includes(hazard.id) && (
            <HazardCard
              key={hazard.id}
              project={project}
              hazard={hazard}
              startHazardEditing={() => startHazardEditing(hazard)}
            />
          )}

          {(!hazard.id || editingHazards.includes(hazard.id)) && (
            <HazardEditableCard
              key={hazard.id}
              project={project}
              originalHazard={hazard}
              stopHazardEditing={() => stopHazardEditing(hazard)}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
});

export default HazardsList;
